import $ from 'jquery';

$('[data-auto-submit]').each(function() {
  const $this = $(this);
  // Get all form child elements excluding the submit button
  const $formEls = $this.find('input, select, button, textarea').not('[type="submit"],[type="text"]');
  // Submit form when any elements are changed
  $formEls.on('change', function() {
    $this.submit();
  });
});